<script>
export default {
    props: ['publicPage', 'customer', 'availableBookings', 'backgroundColor','courseInstructors', 'courses','isMobile'],
    methods: {
        getWidth() {
            if(this.isMobile)
                return '100%';

            var noOfColumns = 2;
            if(this.availableBookings.length)
                noOfColumns++;

            if(this.courses.length > 0)
                noOfColumns++;

            if(this.courseInstructors.length > 0)
                noOfColumns++;
             
            return 100/noOfColumns + '%';
        }
    }
}
</script>
<template>
    <footer :style="{ 'background-color': backgroundColor }">
        <section :style="{ '--width':getWidth(), '--direction': isMobile ? 'column': 'row' }">
        <div>           
            <b>MENY</b> 
            <ul>
                <li>
                    Hem     
                </li>
                <li>
                    {{this.$store.state.settings.Community.singular}}     
                </li>
                <li v-if="publicPage.include_image_gallery">
                    {{this.$store.state.settings.ImageGallery.singular}}
                </li>                     
                <li v-if="publicPage.include_contact">
                    Kontakta Oss      
                </li>                  
            </ul>     
        </div>
        <div v-if="availableBookings.length > 0">
            <b style="text-transform: uppercase;">{{this.$store.state.settings.BookingItem.plural}}</b>
            <ul>
                <li v-for="booking in availableBookings">
                    {{ booking.name }}                                                                           
                </li>
            </ul>
        </div>
        <div v-if="courses.length > 0">
            <b style="text-transform: uppercase;">{{this.$store.state.settings.Course.plural}}</b>
            <ul>
                <li v-for="course in courses">
                    {{ course.name }}                                                                           
                </li>
            </ul>
        </div>
        <div v-if="courseInstructors.length > 0">
            <b style="text-transform: uppercase;">{{this.$store.state.settings.CourseInstructor.plural}}</b>
            <ul>
                <li v-for="instructor in courseInstructors">
                    {{ instructor.name }}                                                                           
                </li>
            </ul>
        </div>
        <div>
            <img src="@/assets/imgs/new_logo.png" style="opacity: 0.2; width: 130px;"><br>
            &copy; {{ new Date().getFullYear() }} {{ customer.name }} 
        </div>
        </section>
        <div class="public-footer-samfallify" :style="{ 'color': backgroundColor }">{{ customer.name }} är en del av jamiis&copy; härliga community.</div>                    
</footer>
</template>

<style scoped>
  footer
{
    background-color: black;
    width:100%;
    filter: brightness(90%);
    padding: 70px 0px;
}

.public-footer-samfallify 
{
    position: absolute;
    bottom: 7px;
    right: 7px;
    font-size: 12px;  
    filter: brightness(70%);
}
footer ul
{
    list-style: none;
    padding: 0px;
}

footer li
{
   margin-bottom:10px;
   cursor: pointer;
}

footer i
{
    filter: brightness(110%);
    font-size: 70pt;
    padding: 15px;
}

section {
    display: flex;
    justify-content: center;
    font-family: Poppins, sans-serif;
    width: 70%;
    margin: auto;
    gap: 20px;
    flex-direction: var(--direction);
}

section div {
    width: var(--width)
    
}

</style>